import React, { useState } from 'react';
import { Button, Input, Modal } from 'antd';
import { MinusCircleIcon } from '@heroicons/react/24/solid';

interface IProps {
  open: boolean;
  title: string;
  content: string;
  isRemark?: boolean;
  handleOk: (remark?: string) => void;
  handleCancel: () => void;
}

const DeleteConfirmModal = ({
  open,
  content,
  handleOk,
  handleCancel,
  isRemark,
}: IProps) => {
  const [remark, setRemark] = useState('');
  const onBeforeOk = () => {
    handleOk(remark);
  };
  return (
    <Modal
      width={400}
      open={open}
      onOk={() => onBeforeOk}
      onCancel={handleCancel}
      okText="บันทึก"
      cancelText="ยกเลิก"
      footer={
        <div className="flex w-full gap-2 justify-center">
          <Button key="back" onClick={handleCancel}>
            ยกเลิก
          </Button>
          <Button
            key="submit"
            type="primary"
            form="unit"
            onClick={onBeforeOk}
            className="bg-red-700 !hover:bg-red-700"
          >
            ยืนยัน
          </Button>
        </div>
      }
    >
      <div className="flex flex-row w-full gap-5 items-center text-lg">
        <div>
          <MinusCircleIcon className="w-10 h-10 text-red-700" />
        </div>
        <div>{content}</div>
      </div>
      {isRemark && (
        <div className="flex w-full mt-2">
          <Input.TextArea
            placeholder="หมายเหตุ"
            onChange={e => setRemark(e.target.value)}
          />
        </div>
      )}
    </Modal>
  );
};

export default DeleteConfirmModal;
